module.exports = __webpack_public_path__ + "static/media/fatcat.e88fc604.jpg";